import _ from 'lodash';
import React from 'react';
import { WidgetTruncatedText } from './WidgetTruncatedText';

export function WidgetTitleSubtitle ({
    title,
    extraTitle = null,
    subtitle = null,
    align = 'left',
    classNameTitle = '',
    truncateTitle = true,
    truncateTitleOptions = {},
    classNameSubtitle = 'text-muted',
    truncateSubtitle = true,
    truncateSubtitleOptions = {}
}) {
    if (_.isString(extraTitle) && truncateTitle) {
        title = (<WidgetTruncatedText text={extraTitle} options={truncateTitleOptions} />);
    }
    if (_.isString(title) && truncateTitle) {
        title = (<WidgetTruncatedText text={title} options={truncateTitleOptions} />);
    }

    if (_.isString(subtitle) && truncateSubtitle) {
        subtitle = (<WidgetTruncatedText text={subtitle} options={truncateSubtitleOptions} />);
    }

    return (
        <div className={`d-flex flex-column text-${align}`}>
            <span className={classNameTitle}>{title}</span>
            {extraTitle && (<span className={classNameSubtitle}>{extraTitle}</span>)}
            <span hidden={_.isNil(subtitle)} className={classNameSubtitle}>{subtitle}</span>
        </div>
    );
}

// Set display names for debugging.
if (process.env.NODE_ENV !== 'production') {
    WidgetTitleSubtitle.displayName = 'WidgetTitleSubtitle';
}
